// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ArDY","checkboxCol":"Table_checkboxCol__3slyJ","emailCol":"Table_emailCol__35j5H","actionCol":"Table_actionCol___ahR1"};